import { Route } from 'react-router-dom';
import ProtectedRoute from '../Components/Stateless/ProtectedRoute';
import MainLayout from '../Layout/MainLayout';

// Pages
import ManageCuisine from '../Components/Stateless/ManageCuisine';
import ManageItemCategory from '../Components/Stateless/ManageItemCategory';
import ManageItemSubCategory from '../Components/Stateless/ManageItemSubCategory';
import ManageCustomer from '../Components/Stateless/ManageCustomer/ManageCustomerList';
import ManageChoiceGroup from '../Components/Statefull/ChoiceGroup/ManageChoiceGroup';
import ManageChoices from '../Components/Statefull/ManageChoices/ManageChoices';
import ManageDriver from '../Components/Statefull/DriverManagement/ManageDriver';
import ManageDeliveryManager from '../Components/Statefull/AdminDeliveryManager/DeliveryManager';
import FaqList from '../Components/Statefull/ManageFaqs/FaqList';
import ManageCMS from '../Components/Statefull/ManageCMS/ManageCMS';
import WalletList from '../Components/Statefull/ManageWallet/WalletList';
import WalletHistory from '../Components/Statefull/ManageWallet/WalletHistory';
import OrderList from '../Components/Statefull/OrderManagement/OrderList';
import SettingsList from '../Components/Statefull/Settings/SettingsList';
import BannerSettingsTable from '../Components/Statefull/Settings/BannerSettings/BannerSettingsTable';
import StoreOwner from '../Components/Statefull/StoreOwner/StoreOwner';
import ManageRestaurantList from '../Components/Statefull/StoreManagement/ManageRestaurantList';
import SubAdminList from '../Components/Statefull/SubAdmin/SubAdminList';
import AddStoreOwner from '../Components/Statefull/AddStoreOwner';
import AddCustomer from '../Components/Statefull/Customer/AddCustomer';
import ManageCoupon from '../Components/Stateless/ManageCoupon';
import { AddStoreItemWrapper, EditRestaurantWrapper, ManageStoreItemWrapper, AddSubAdminWrapper, AddRestaurantWrapper, EditSubAdminWrapper } from '../wrappers/RouteWrappers';
import StockManagement from '../Components/Statefull/StockManagement/StockManagement';
import ManageRestaurantReview from '../Components/Statefull/ReviewManagement/ManageRestaurantReview';
import ManageOrderReview from '../Components/Statefull/ReviewManagement/ManageOrderReview';
import DeliveryBoyMap from '../Components/Statefull/DeliveryBoyMap/DeliveryBoyMap';
import { MQTTProvider } from '../context/MQTTContext';
import NewsLetter from '../Components/Statefull/NewsLetter/NewsLetter';
import ReferalManagement from '../Components/Statefull/ReferalManagement/ReferalManagement';
import ManageOffers from '../Components/Statefull/PromotionalOffersAndLoyaltyRewards/ManageOffers';
import AssignOffers from '../Components/Statefull/PromotionalOffersAndLoyaltyRewards/AssignOffers';
import Dashboard from '../Components/Statefull/Dashboard/Dashboard';
import PaymentSettings from '../Components/Statefull/Settings/PaymentSettings/PaymentSettings';
import PushNotification from '../Components/Statefull/PushNotification/PushNotification';
import Settlements from '../Components/Statefull/Settlements/Settlements';
import TrackOrderPage from '../Components/Statefull/OrderManagement/TrackOrderPage';
import RestaurantEarningReports from '../Components/Statefull/Reports/RestaurantEarningReports';
import OrderSummaryReport from '../Components/Statefull/Reports/OrderSummaryReport';
import CancelledOrdersReport from '../Components/Statefull/Reports/CancelledOrdersReport';
import RejectedOrdersReport from '../Components/Statefull/Reports/RejectedOrdersReport';
import PendingOrdersReport from '../Components/Statefull/Reports/PendingOrdersReport';
import DeliveryPerformanceReport from '../Components/Statefull/Reports/DeliveryPerformanceReport';
import AdminCommissionReport from '../Components/Statefull/Reports/AdminCommissionReport';
import MerchantPayoutReport from '../Components/Statefull/Reports/MerchantPayoutReport';
import DriverPayoutReport from '../Components/Statefull/Reports/DriverPayoutReport';
import RefundReport from '../Components/Statefull/Reports/RefundReport';
import JoinUsManagement from '../Components/Statefull/JoinUs/JoinUsManagement';


const ProtectedRoutes = () => {
  return (
    <>
      <Route
        element={
          <ProtectedRoute>
            <MQTTProvider>
              <MainLayout />
            </MQTTProvider>
          </ProtectedRoute>
        }
      >
        {/* Settings */}
        <Route path="/settings/general" element={<SettingsList />} />
        <Route path="/bannerSettings" element={<BannerSettingsTable />} />
        <Route path="/settings/payment" element={<PaymentSettings />} />

        {/* Cuisine & Category Management */}
        <Route path="/managecuisine" element={<ManageCuisine />} />
        <Route path="/manageItemCategory" element={<ManageItemCategory />} />
        <Route path="/manageItemSubCategory/:categoryId" element={<ManageItemSubCategory />} />

        {/* Customer Management */}
        <Route path="/manageCustomer" element={<ManageCustomer />} />
        <Route path="/add-customer" element={<AddCustomer />} />

        {/* Join Us Management */}
        <Route path="/join-us" element={<JoinUsManagement />} />

        {/* Store Items & Choice Management */}
        <Route path="/manage-choice-group" element={<ManageChoiceGroup />} />
        <Route path="/manage-choice" element={<ManageChoices />} />
        <Route path="/addStoreItem" element={<AddStoreItemWrapper />} />
        <Route path="/manageStoreItem" element={<ManageStoreItemWrapper />} />

        {/* Sub Admin Management */}
        <Route path="/sub-admin/add" element={<AddSubAdminWrapper />} />
        <Route path="/sub-admin/add/:id" element={<EditSubAdminWrapper />} />
        <Route path="/sub-admin/list" element={<SubAdminList />} />

        {/* Restaurant/Store Management */}
        <Route path="/store-owner" element={<StoreOwner />} />
        <Route path="/store-owner/add" element={<AddStoreOwner />} />
        <Route path="/manage-store" element={<ManageRestaurantList />} />
        <Route path="/addRestaurant" element={<AddRestaurantWrapper />} />
        <Route path="/restaurant/edit/:id" element={<EditRestaurantWrapper />} />

        {/* Delivery Management */}
        <Route path="/delivery-boy" element={<ManageDriver />} />
        <Route path="/admin-delivery" element={<ManageDeliveryManager />} />

         {/* Settlements */}
        <Route path="/settlements" element={<Settlements />} />

        {/* Push Notification */}
        <Route path="/push-notification" element={<PushNotification />} />

        {/* Orders, Coupons, CMS */}
        <Route path="/manageOrder" element={<OrderList />} />
        <Route path="/track-order" element={<TrackOrderPage />} />
        <Route path="/manageCoupon" element={<ManageCoupon />} />
        <Route path="/manage-CMS" element={<ManageCMS />} />

        {/* FAQ, Stock, Wallet */}
        <Route path="/manage-FAQ" element={<FaqList />} />
        <Route path="/manageStock" element={<StockManagement />} />
        <Route path="/manageWallet" element={<WalletList />} />
        <Route path="/wallet-history" element={<WalletHistory />} />

        {/* Review Management */}
        <Route path="/manage-restaurant-review" element={<ManageRestaurantReview />} />
        <Route path="/manage-order-review" element={<ManageOrderReview />} />

        {/* Delivery boy map */}
        <Route path="/delivery-boy-map" element={<DeliveryBoyMap />} />

         {/* Delivery boy map */}
        <Route path="/delivery-boy-map" element={<DeliveryBoyMap />} />

        {/* newsletter-management */}
        {/* newsletter-management */}
        <Route path="/newsletter-management" element={<NewsLetter />} />

        {/* referal-management */}
        <Route path="/refer-friend-report" element={<ReferalManagement />} />

        {/* Promotional Offers and Loyalty */}
        <Route path="/Manage-Offers" element={<ManageOffers />} />
        <Route path="/assign-offers" element={<AssignOffers />} />

        {/* Reports */}
        <Route path="/reports/store-earning-reports" element={<RestaurantEarningReports />} />
        <Route path="/reports/order-summary" element={<OrderSummaryReport />} />
        <Route path="/reports/cancelled-orders" element={<CancelledOrdersReport />} />
        <Route path="/reports/rejected-orders" element={<RejectedOrdersReport />} />
        <Route path="/reports/pending-orders" element={<PendingOrdersReport />} />
        <Route path="/reports/delivery-performance" element={<DeliveryPerformanceReport />} />
        <Route path="/reports/admin-commission" element={<AdminCommissionReport />} />
        <Route path="/reports/merchant-payout" element={<MerchantPayoutReport />} />
        <Route path="/reports/driver-payout" element={<DriverPayoutReport />} />
        <Route path="/reports/refund" element={<RefundReport />} />

         {/* dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
        
      </Route>
    </>
  );
};

export default ProtectedRoutes;
